export const INITIAL_LOGIN_PATTERN = {
  WORKHUB_EXISTING_CUSTOMER: 'workhub_existing_customer',
  WORKHUB_NO_CUSTOMER: 'workhub_no_customer',
  TERMS_NOT_ACCEPTED: 'terms_not_accepted',
} as const;

export type InitialLoginPattern =
  (typeof INITIAL_LOGIN_PATTERN)[keyof typeof INITIAL_LOGIN_PATTERN];

export const PASSWORD_RESET_PATTERN = {
  INITIAL: 'initial',
  NORMAL: 'normal',
} as const;

export type PasswordResetPattern =
  (typeof PASSWORD_RESET_PATTERN)[keyof typeof PASSWORD_RESET_PATTERN];

export const PASSWORD_RESET_TOKEN_KEY = 'passwordResetToken';
